module.exports = __webpack_public_path__ + "img/center-bottom.11a9b003.png";